module.exports = __webpack_public_path__ + "img/4.e673b270.png";